/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Attributes_InvalidInputs */

const en_error_attributes_invalid = /** @type {(inputs: Error_Attributes_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some attributes cannot be saved.`)
};

/**
* | output |
* | --- |
* | "Some attributes cannot be saved." |
*
* @param {Error_Attributes_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_attributes_invalid = /** @type {((inputs?: Error_Attributes_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Attributes_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_attributes_invalid(inputs)
});